import type { IHistoryPresidents, IPresident } from '@/types';

export const presidents: IHistoryPresidents['presidents'] = [
  {
    id: 2,
    name: 'Gilberto Madaíl',
    profile_image: {
      path: 'https://admin.fpf.gemadigital.com/uploads/Presidentes/Gilberto-Madail-251x251.png',
      mime_type: 'image/png',
      caption: null,
    },
    has_details: false,
    start_date: new Date('2011-12-17T00:00:00.000000Z'),
    end_date: new Date('1996-12-31T00:00:00.000000Z'),
    is_current: false,
  },
  {
    id: 5,
    name: 'Vítor Vasques',
    profile_image: {
      path: 'https://admin.fpf.gemadigital.com/uploads/Presidentes/Vitor-Vasques-251x251.png',
      mime_type: 'image/png',
      caption: null,
    },
    has_details: false,
    start_date: new Date('2011-12-17T00:00:00.000000Z'),
    end_date: new Date('1996-12-31T00:00:00.000000Z'),
    is_current: false,
  },
  {
    id: 3,
    name: 'João Rodrigues',
    profile_image: {
      path: 'https://admin.fpf.gemadigital.com/uploads/Presidentes/Joao-Rodrigues-251x251.png',
      mime_type: 'image/png',
      caption: null,
    },
    has_details: false,
    start_date: new Date('2011-12-17T00:00:00.000000Z'),
    end_date: new Date('1992-12-31T00:00:00.000000Z'),
    is_current: false,
  },
  {
    id: 4,
    name: 'Silva Resende',
    profile_image: {
      path: 'https://admin.fpf.gemadigital.com/uploads/Presidentes/Silva-Resende-251x251.png',
      mime_type: 'image/png',
      caption: null,
    },
    has_details: false,
    start_date: new Date('2011-12-17T00:00:00.000000Z'),
    end_date: new Date('1989-01-01T00:00:00.000000Z'),
    is_current: false,
  },
  {
    id: 6,
    name: 'Francisco Mega',
    profile_image: {
      path: 'https://admin.fpf.gemadigital.com/uploads/Presidentes/Francisco-Mega-251x251.png',
      mime_type: 'image/png',
      caption: null,
    },
    has_details: false,
    start_date: new Date('2011-12-17T00:00:00.000000Z'),
    end_date: new Date('1963-01-01T00:00:00.000000Z'),
    is_current: false,
  },
];

export const presidentDetail: IPresident = {
  id: 1,
  name: 'FERNANDOGOMES',
  profile_image: {
    path: 'https://admin.fpf.gemadigital.com/uploads/president-profile.png',
    mime_type: 'image/png',
    caption: null,
  },
  has_details: false,
  start_date: new Date('2011-12-17T00:00:00.000000Z'),
  end_date: null,
  is_current: true,
  full_body_image: {
    path: 'https://admin.fpf.gemadigital.com/uploads/president.png',
    mime_type: 'image/png',
    caption: null,
  },
  description: '',
  extra_info: null,
};
